var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Student as StudentModel } from '@/models/Student';
import PageHeader from '@/components/page-header/PageHeader';
import Levels from '@/views/Users/Student/Levels';
import Scoolfolio from '@/views/Users/Student/Scoolfolio';
import { excludeRoles } from '@/support/ExcludeRoles';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { Guardian } from '@/models/Guardian';
import { TabsColorEnum } from '@/config/theme';
import { RolesEnum } from '@/items/Roles';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { identifyApplication } from '@/support/Client';
const GUARDIAN_SETTING_KEYS = [
    'guardian_can_see_student_scooltracker',
    'guardian_can_see_student_this_is_me',
    'guardian_can_see_student_portfolio',
    'guardian_can_see_student_finished',
    'guardian_can_see_student_profile',
    'guardian_can_see_student_notes',
    'guardian_can_see_student_roster',
    'guardian_can_use_chat_functions',
    'guardian_can_see_student_lvs',
    'guardian_can_see_student_documents',
];
let Student = class Student extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Student';
        this.activeTab = '';
        this.student = null;
        this.navigationStudents = [];
        this.selectedNavigationStudent = {};
        this.guardianSettings = {};
        this.isChildOfGuardian = false;
        this.isLoading = true;
    }
    get breadcrumbs() {
        return [
            { name: this.$tc('roles.user', 2) },
            { name: this.$tc('roles.student', 2), path: '/students' },
            { name: this.student ? this.student.name || '' : '', path: this.$route.path },
        ];
    }
    get user() {
        return this.$store.state.Auth;
    }
    get canViewScoolTracker() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
            RolesEnum.STUDENT,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_scooltracker) {
            return true;
        }
        return false;
    }
    get canViewThisIsMe() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
            RolesEnum.STUDENT,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_this_is_me) {
            return true;
        }
        return false;
    }
    get canViewPortfolio() {
        // Active in versions: 2,3,4
        if (!(this.isVersion('2') || this.isVersion('3') || this.isVersion('4'))) {
            return false;
        }
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
            RolesEnum.STUDENT,
        ]) &&
            !this.exclude) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_portfolio) {
            return true;
        }
        return false;
    }
    get canViewFinished() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
            RolesEnum.STUDENT,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_finished) {
            return true;
        }
        return false;
    }
    get canViewLevels() {
        if (this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.TEACHER])) {
            return true;
        }
        return false;
    }
    get canViewProfile() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_profile) {
            return true;
        }
        return false;
    }
    get canViewMessages() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
            RolesEnum.STUDENT,
        ]) &&
            !this.exclude) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_use_chat_functions) {
            return true;
        }
        return false;
    }
    get canViewStudentLvs() {
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_lvs) {
            return true;
        }
        return false;
    }
    get canViewRoster() {
        // Active in versions: 3
        if (!this.isVersion('3')) {
            return false;
        }
        if (this.user.hasRole([RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.ROOT])) {
            return true; // always allow them
        }
        const hideRosterSetting = this.$store.getters.getSetting('hide_my_roster');
        const canViewRoster = !(hideRosterSetting && hideRosterSetting.value);
        if (canViewRoster) {
            if (this.user.hasRole([RolesEnum.TRAINER, RolesEnum.TEACHER]) && !this.exclude) {
                return true;
            }
            if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_roster) {
                return true;
            }
        }
        return false;
    }
    get canViewNotes() {
        // Active in versions: 2,3,4
        if (!(this.isVersion('2') || this.isVersion('3') || this.isVersion('4'))) {
            return false;
        }
        if (this.user.hasRole([
            RolesEnum.ROOT,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.TEACHER,
            RolesEnum.BOARD,
        ])) {
            return true;
        }
        if (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_notes) {
            return true;
        }
        return false;
    }
    get canViewStudent() {
        if (this.user.isGuardian && !this.isChildOfGuardian) {
            return false;
        }
        if (this.user.hasRole(RolesEnum.STUDENT) && this.user.id !== this.$route.params.id) {
            return false;
        }
        return true;
    }
    get canViewTreatment() {
        return this.user.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.ROOT,
            RolesEnum.TEACHER,
        ]);
    }
    get canViewPlan() {
        return (this.user.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.ROOT,
            RolesEnum.TEACHER,
        ]) ||
            (this.user.hasRole([RolesEnum.GUARDIAN]) && this.guardianSettings.guardian_can_see_student_documents));
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.navigationItems.includes(this.$store.state.Auth.roles[0].id);
    }
    get version() {
        return this.$store.state.version;
    }
    get currentNavigationStudentIndex() {
        return this.navigationStudents.findIndex((student) => {
            if (this.student) {
                return student.id === this.student.id;
            }
        });
    }
    get isShowingHomeTab() {
        if (!this.student) {
            return false;
        }
        return this.activeTab === `/students/${this.student.id}`;
    }
    get hasAvailableTabs() {
        return this.tabs.some((tab) => tab.is_visible && !!tab.to);
    }
    get tabs() {
        const groupId = this.$route.params.group_id;
        if (!this.student) {
            return [];
        }
        return [
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: this.$tc('navigationCard.student.schoolTracker'),
                icon: 'calculate',
                is_visible: this.canViewScoolTracker,
                label: this.$tc('idp.titleShort'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/school-tracker`
                    : `/students/${this.student.id}/school-tracker`,
            },
            {
                color: TabsColorEnum.PURPLE,
                description: this.$tc('navigationCard.student.portfolio'),
                icon: 'perm_media',
                // SCOOL-476: portfolio tab disabled for all schools (unused, gives an error).
                // Was: is_visible: this.canViewPortfolio — kept until the customer decides otherwise.
                is_visible: false,
                label: this.$tc('portfolio.title'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/portfolio`
                    : `/students/${this.student.id}/portfolio`,
            },
            {
                color: TabsColorEnum.BLUE,
                description: this.$tc('navigationCard.student.thisIsMe'),
                icon: 'face',
                is_visible: this.canViewThisIsMe,
                label: this.$tc('progress.title'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/this-is-me`
                    : `/students/${this.student.id}/this-is-me`,
            },
            {
                color: TabsColorEnum.ORANGE,
                description: this.$tc('navigationCard.student.levels'),
                icon: 'bar_chart',
                is_visible: this.canViewLevels,
                label: this.$tc('level.title2', 2),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/levels`
                    : `/students/${this.student.id}/levels`,
            },
            {
                color: TabsColorEnum.YELLOW,
                description: this.$tc('navigationCard.student.profile'),
                icon: 'person',
                is_visible: this.canViewProfile,
                label: this.$tc('profile.title', 1),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/profile`
                    : `/students/${this.student.id}/profile`,
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: this.$tc('navigationCard.student.messages'),
                icon: 'chat',
                is_visible: this.canViewMessages,
                label: this.$tc('chat.message', 2),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/messages`
                    : `/students/${this.student.id}/messages`,
            },
            {
                color: TabsColorEnum.PINK,
                description: this.$tc('navigationCard.student.notes'),
                icon: 'description',
                is_visible: this.canViewNotes,
                label: this.$tc('subject.tab.notes'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/notes`
                    : `/students/${this.student.id}/notes`,
            },
            {
                color: TabsColorEnum.BLACK,
                description: this.$tc('navigationCard.student.treatment'),
                icon: 'help',
                is_visible: this.canViewTreatment,
                label: this.$tc('subject.tab.treatment'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/treatment`
                    : `/students/${this.student.id}/treatment`,
            },
            {
                color: TabsColorEnum.BLUE,
                description: this.$tc('navigationCard.student.plan', 2),
                icon: 'receipt_long',
                is_visible: this.canViewPlan,
                label: this.$tc('student_plan.title', 2),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/plan`
                    : `/students/${this.student.id}/plan`,
            },
            {
                color: TabsColorEnum.GREY,
                description: this.$tc('navigationCard.student.levels'),
                icon: 'menu_book',
                is_visible: this.canViewStudentLvs,
                label: this.$tc('subject.tab.lvs'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/lvs`
                    : `/students/${this.student.id}/lvs`,
            },
            {
                color: TabsColorEnum.RED,
                description: this.$tc('navigationCard.student.finished'),
                icon: 'thumb_up',
                is_visible: this.canViewFinished,
                label: this.$tc('profile.finished.title'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/finished`
                    : `/students/${this.student.id}/finished`,
            },
            {
                color: TabsColorEnum.DARK_GREEN,
                description: this.$tc('navigationCard.student.roster'),
                icon: 'event',
                is_visible: this.canViewRoster,
                label: this.$tc('subject.tab.roster'),
                to: groupId
                    ? `/groups/${groupId}/students/${this.student.id}/roster`
                    : `/students/${this.student.id}/roster`,
            },
        ];
    }
    get unauthorizedDialogOptions() {
        return {
            title: this.$t('dialogOptions.forbidden').toString(),
            text: '',
            type: 'error',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => { },
                },
            },
        };
    }
    async mounted() {
        if (this.user.isGuardian) {
            await this.compareChildren();
        }
        if (this.canViewStudent) {
            this.initialize();
            this.setSettings();
            return;
        }
        this.$store.dispatch('openDialog', this.unauthorizedDialogOptions);
    }
    tabStyle(tab) {
        if (!tab) {
            return;
        }
        if (!tab.color) {
            return;
        }
        if (this.isActiveTab(tab)) {
            return {
                backgroundColor: tab.color,
            };
        }
        return {
            borderBottom: `4px solid ${tab.color}`,
        };
    }
    sync(student) {
        this.student = student;
    }
    nextStudent(indexTo) {
        return this.navigationStudents[this.currentNavigationStudentIndex + indexTo];
    }
    navigateToStudent(indexTo) {
        const student = this.nextStudent(indexTo);
        if (student) {
            this.toStudentRoute(student);
        }
    }
    studentNavigationFilter(student) {
        this.toStudentRoute(student);
    }
    toStudentRoute(student) {
        if (!student) {
            return;
        }
        this.$router.push({
            name: this.$route.name || '',
            params: {
                id: student.id || '',
                group_id: this.$route.params.group_id,
            },
            query: {
                ...(this.$route.query ? this.$route.query : {}),
            },
        });
    }
    async compareChildren() {
        await new Guardian()
            .include(['relationships'])
            .filter('relationship', 'child')
            .find(this.user.id)
            .then((guardian) => {
            const children = guardian.relationships;
            this.isChildOfGuardian = !!children.find((child) => child.user.id === this.$route.params.id);
        });
        return false;
    }
    setSettings() {
        if (!this.user.isGuardian) {
            return;
        }
        this.guardianSettings = GUARDIAN_SETTING_KEYS.reduce((settings, key) => {
            const setting = this.$store.state.settings.find((storeSetting) => storeSetting.key === key);
            settings[key] = !!setting && (setting.value === '1' || setting.value === true);
            return settings;
        }, {});
    }
    async initialize() {
        this.isLoading = true;
        let includes = [];
        this.student = null;
        if (!this.exclude || this.isVersion('2') || this.isVersion('4')) {
            includes = [
                'chat',
                'level',
                'relationships',
                'student',
                'period',
                'token',
                'tags',
                'portfolio',
                'projects',
                'treatment_labels',
            ];
        }
        else {
            includes = [
                'level',
                'student',
                'period',
                'token',
                'tags',
                'portfolio',
                'projects',
                'treatment_labels',
            ];
        }
        await new StudentModel()
            .include(includes)
            .find(this.$route.params.id)
            .then((student) => {
            this.student = student;
            if (this.user.isGuardian) {
                this.rerouteForGuardian();
            }
            else {
                this.reroute();
            }
        });
        if (this.$route.params.group_id) {
            await new StudentModel()
                .include(['treatment_labels', 'treatment'])
                .filter({ group: this.$route.params.group_id })
                .limit(999)
                .all()
                .then((items) => {
                this.navigationStudents = items;
                this.selectedNavigationStudent = items.find((student) => student.id === this.$route.params.id);
            })
                .catch((error) => console.log(error));
        }
        this.isLoading = false;
    }
    reroute() {
        const groupId = this.$route.params.group_id;
        if (!this.student) {
            return;
        }
        if (this.exclude && this.isVersion('1')) {
            this.$router.push(`/students/${this.student.id}/finished`);
            this.activeTab = `/students/${this.student.id}/finished`;
        }
        else if (window.location.pathname.includes('profile')) {
            this.activeTab = `/students/${this.student.id}/profile`;
        }
        else if (window.location.pathname.includes('finished')) {
            this.activeTab = `/students/${this.student.id}/finished`;
        }
        else if (window.location.pathname.includes('levels')) {
            this.activeTab = `/students/${this.student.id}/levels`;
        }
        else if (window.location.pathname.includes('messages')) {
            this.activeTab = `/students/${this.student.id}/messages`;
        }
        else if (window.location.pathname.includes('portfolio')) {
            this.activeTab = `/students/${this.student.id}/portfolio`;
        }
        else if (window.location.pathname.includes('this-is-me')) {
            this.activeTab = `/students/${this.student.id}/this-is-me`;
        }
        else if (window.location.pathname.includes('notes')) {
            this.activeTab = `/students/${this.student.id}/notes`;
        }
        else if (window.location.pathname.includes('treatment')) {
            this.activeTab = `/students/${this.student.id}/treatment`;
        }
        else if (window.location.pathname.includes('school-tracker')) {
            this.activeTab = groupId
                ? `/groups/${groupId}/students/${this.student.id}/school-tracker`
                : `/students/${this.student.id}/school-tracker`;
        }
        else if (window.location.pathname.includes('lvs')) {
            this.activeTab = `/students/${this.student.id}/lvs`;
        }
        else if (window.location.pathname.includes('plan')) {
            this.activeTab = `/students/${this.student.id}/plan`;
        }
        else {
            this.activeTab = `/students/${this.student.id}/`;
        }
    }
    // FIXME obsolete since added tabs
    rerouteForGuardian() {
        const keys = Object.keys(this.$refs).filter((key) => {
            return key.includes('student-tab');
        });
        const tabs = [];
        keys.forEach((key) => {
            const tab = this.$refs[key];
            if (tab) {
                tabs.push(key);
            }
        });
        if (tabs.length) {
            const activeTab = tabs[0].replace('student-tab_', '');
            // if (activeTab === 'scooltracker') {
            //   activeTab = '';
            // }
            if (!this.student) {
                return;
            }
            this.$router.push(`/students/${this.student.id}/${activeTab}`);
            this.activeTab = `/students/${this.student.id}/${activeTab}`;
        }
    }
    isVersion(version) {
        // No Strict comparison because some we have a number and sometimes a sting...
        return version == this.$store.state.version;
    }
    isActiveTab(tab) {
        return tab && tab.to && this.activeTab === tab.to;
    }
    onMouseOver(event, tab) {
        document.documentElement.style.setProperty('--hover-color', tab.color || 'transparent');
    }
    get application() {
        return identifyApplication();
    }
    routeChanged(studentId) {
        if (studentId) {
            this.initialize();
        }
    }
};
__decorate([
    Watch('$route.params.id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Student.prototype, "routeChanged", null);
Student = __decorate([
    Component({
        components: {
            PageHeader,
            Levels,
            Scoolfolio,
            LoaderCard,
            SelectFilter,
        },
    })
], Student);
export default Student;
